import { Icon } from "@/shared/components";
import { cn } from "@/shared/utils";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { useId } from "react";

type SwitchProps = React.ComponentProps<typeof SwitchPrimitive.Root> & {
    label?: string;
    labelPosition?: "left" | "right";
};

export function Switch({ label, labelPosition = "right", className, ...props }: SwitchProps) {
    const id = useId();
    return (
        <div className={cn("flex w-full items-center gap-2", labelPosition === "left" && "justify-between", className)}>
            {label && labelPosition === "left" && (
                <label htmlFor={id} className="text-content-default text-m leading-l">
                    {label}
                </label>
            )}

            <SwitchPrimitive.Root
                {...props}
                id={id}
                className={cn(
                    "group relative inline-flex h-5 w-10 cursor-pointer items-center rounded-full transition-all duration-300",
                    "data-[state=checked]:bg-success-default data-[state=unchecked]:bg-alpha-default",
                    "disabled:cursor-not-allowed disabled:opacity-50"
                )}
            >
                <span className="pointer-events-none absolute transition-all duration-300 group-data-[state=checked]:left-[2px] group-data-[state=unchecked]:right-[2px]">
                    <Icon
                        name="check"
                        size="xs"
                        className="text-content-default-inverse flex items-center group-data-[state=unchecked]:hidden"
                    />
                    <Icon
                        name="close"
                        size="xs"
                        className="text-content-default-inverse flex items-center group-data-[state=checked]:hidden"
                    />
                </span>

                <SwitchPrimitive.Thumb
                    className={`bg-default block h-4 w-4 translate-x-0.5 rounded-full shadow-md transition-transform duration-300 will-change-transform data-[state=checked]:translate-x-5.5`}
                />
            </SwitchPrimitive.Root>

            {label && labelPosition === "right" && (
                <label htmlFor={id} className="text-content-default text-m leading-l">
                    {label}
                </label>
            )}
        </div>
    );
}
